module.exports = __webpack_public_path__ + "static/media/fullstack.728d419b.svg";